module.exports = __webpack_public_path__ + "static/media/priest_framed2.7a516d3f.png";